/* screens/auth/LegalStub.jsx — правовые страницы (/legal/offer · /legal/privacy).
   Рендерит полный юридический текст из legalContent.js (автоген из исходных .docx:
   Пользовательское соглашение / Политика конфиденциальности). Самодостаточная страница
   (вне AuthLayout) с прозой и кнопкой назад. Ссылки в SignUp/футере ведут сюда (фикс №21). */

import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { BackLink } from '../../components/ui/Buttons.jsx';
import { RR } from '../../lib/router.jsx';
import { LEGAL } from './legalContent.js';

  const { useLocation } = RR;

  // маркеры списков из исходных документов
  function isBullet(t) {
    return /^[•●▪\-–]\s/.test(t) || t.startsWith('●') || t.startsWith('•');
  }
  function stripBullet(t) {
    return t.replace(/^[•●▪\-–]\s*/, '');
  }

  // группируем подряд идущие пункты-маркеры в один <ul>, остальное — абзацы
  function renderItems(items) {
    const out = [];
    let bucket = null;
    items.forEach((t, i) => {
      if (isBullet(t)) {
        if (!bucket) { bucket = []; out.push({ type: 'ul', items: bucket, key: 'ul-' + i }); }
        bucket.push(stripBullet(t));
      } else {
        bucket = null;
        out.push({ type: 'p', text: t, key: 'p-' + i });
      }
    });
    return out.map((node) =>
      node.type === 'ul'
        ? <ul key={node.key} className="legal-page__list">{node.items.map((it, j) => <li key={j} className="t-body text-dim">{it}</li>)}</ul>
        : <p key={node.key} className="t-body text-dim legal-page__p">{node.text}</p>,
    );
  }

  function LegalStub() {
    const { pathname } = useLocation();
    const auth = useAuth ? useAuth() : null;
    const doc = pathname.endsWith('privacy') ? LEGAL.privacy : LEGAL.offer;
    // правовые страницы публичны: гость → вход, залогинен → ассистент
    const backFallback = auth && auth.user ? '/chat' : '/signin';

    return (
      <div className="legal-page">
        <div className="legal-page__inner stack stack-16">
          <BackLink to={backFallback}>Назад</BackLink>
          <header className="stack stack-6">
            <div className="t-eyebrow">Правовая информация</div>
            <h1 className="t-display legal-page__title">{doc.title}</h1>
            {doc.edition && <p className="t-caption text-mute">{doc.edition}</p>}
          </header>

          {doc.intro && doc.intro.length > 0 && (
            <div className="stack stack-8 legal-page__intro">
              {doc.intro.map((t, i) => <p key={i} className="t-body text-dim">{t}</p>)}
            </div>
          )}

          <div className="stack stack-16 legal-page__body">
            {doc.sections.map((s) => (
              <section key={s.heading} className="stack stack-6">
                <h2 className="t-h3">{s.heading}</h2>
                {renderItems(s.items)}
              </section>
            ))}
          </div>
        </div>
      </div>
    );
  }

export { LegalStub };
